import communityItemConnector from "../community-item-connector"

import CommunityViewItem from "./CommunityViewItem"

export default communityItemConnector(CommunityViewItem)
